"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Select = void 0;

var tslib_1 = require("tslib");

var styled_components_1 = tslib_1.__importStar(require("styled-components"));

var isDoubleStyles = (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n"], ["\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n"])));
exports.Select = styled_components_1.default.div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  flex-grow: 1;\n  cursor: default;\n  ", "\n"], ["\n  flex-grow: 1;\n  cursor: default;\n  ", "\n"])), function (_a) {
  var isDouble = _a.isDouble;
  return isDouble && isDoubleStyles;
});
var templateObject_1, templateObject_2;